/**
 * Calculate cart total including discounts and optional modifier groups.
 */
const hasActiveDiscount = (item) => {
  if (
    !item.discount ||
    item.discount <= 0 ||
    item.discount_type !== "porcentaje"
  ) {
    return false;
  }

  const start = item.discount_start_date
    ? new Date(item.discount_start_date)
    : null;
  const end = item.discount_end_date
    ? new Date(item.discount_end_date)
    : null;
  const now = new Date();

  if (start && Number.isNaN(start.getTime())) {
    return false;
  }

  if (end && Number.isNaN(end.getTime())) {
    return false;
  }

  if (start && now < start) {
    return false;
  }

  if (end && now > end) {
    return false;
  }

  return true;
};

export const calculateCartTotal = (cart, selectedQuantities, products) => {
  return cart.reduce((acc, item) => {
    // Apply discount if available
    let itemPrice = item.price;
    if (hasActiveDiscount(item)) {
      itemPrice = item.price * (1 - item.discount / 100);
    }

    let acompanantesPrice = 0;

    // Only calculate modifier groups if the product has them
    if (
      Array.isArray(item.modifier_groups) &&
      item.modifier_groups.length > 0
    ) {
      item.modifier_groups.forEach((group) => {
        if (Array.isArray(group.app_mg_items)) {
          group.app_mg_items.forEach((acompanante) => {
            // Look up price from the acompanantes list on the cart item
            const acompananteInfo = item.acompanantes
              ? item.acompanantes.find(
                (a) => a.app_item_id === acompanante.app_item_id
              )
              : null;

            const acompanantePrice = acompananteInfo
              ? acompananteInfo.price
              : 0;

            const selectedQuantity =
              selectedQuantities[
              `${item.item_id}-${acompanante.app_item_id}`
              ] || 0;

            acompanantesPrice += acompanantePrice * selectedQuantity;
          });
        }
      });
    }

    // Include subproducts prices (new API format)
    if (
      Array.isArray(item.subproducts) &&
      item.subproducts.length > 0
    ) {
      item.subproducts.forEach((sub) => {
        const subKey = `${item.item_id}-sub-${sub.item_id}`;
        const selectedQuantity = selectedQuantities[subKey] || 0;
        acompanantesPrice += sub.price * selectedQuantity;
      });
    }

    return acc + itemPrice * item.quantity + acompanantesPrice;
  }, 0);
};
